<div class="modal" [ngClass]="{ hidde: showCancel }">
  <div class="modal-content">
    <div class="modal-title">
      <h4 class="title">Agregar un nuevo cliente</h4>
      <div class="modal-close">
        <button type="button" (click)="cancel()">&#10799;</button>
      </div>
    </div>

    <div class="modal-body">
      <form [formGroup]="form" autocomplete="off">
        <p class="subtitule-2">Datos personales</p>
        <div>
          <div class="form-row">
            <div class="ggi-input">
              <input
                type="text"
                id="firstName"
                formControlName="firstName"
                ggiJourneyControlValidator
                [submitted]="form.get('firstName')?.touched"
              />
              <label for="firstName">Nombre</label>
            </div>
            <div class="ggi-input">
              <input
                type="text"
                id="lastName"
                formControlName="lastName"
                ggiJourneyControlValidator
                [submitted]="form.get('lastName')?.touched"
              />
              <label for="lastName">Apellidos</label>
            </div>
          </div>
          <div class="ggi-input">
            <input
              type="email"
              id="email"
              formControlName="email"
              ggiJourneyControlValidator
              [submitted]="form.get('email')?.touched"
            />
            <label for="email">Correo</label>
          </div>
          <div class="ggi-input">
            <input
              type="text"
              id="phone"
              formControlName="phone"
              [mask]="MaskPhone"
              ggiJourneyControlValidator
              [submitted]="form.get('phone')?.touched"
            />
            <label for="phone">Teléfono</label>
          </div>
          <div class="ggi-input">
            <input
              type="text"
              id="company"
              formControlName="company"
              ggiJourneyControlValidator
              class="ggi-optional"
              [submitted]="form.get('company')?.touched"
            />
            <label for="company">Empresa</label>
          </div>

          <div class="radios">
            <div class="ggi-radio">
              <input
                type="radio"
                id="virtual"
                value="Alta"
                formControlName="priority"
              />
              <label for="virtual">Alta</label>
            </div>
            <div class="ggi-radio">
              <input
                type="radio"
                id="physical"
                value="media"
                formControlName="priority"
              />
              <label for="physical">Media</label>
            </div>
            <div class="ggi-radio">
              <input
                type="radio"
                id="physical"
                value="baja"
                formControlName="priority"
              />
              <label for="physical">Baja</label>
            </div>
          </div>

          <p class="subtitule-2">{{ questionI?.question }} (Opcional)</p>
          <div class="radios-content">
            <label
              class="ggi-radio"
              *ngFor="let answerOption of questionI?.answers"
            >
              <input
                type="radio"
                formControlName="answer"
                class="checkbox-question"
                value="{{ answerOption.text }}"
                id="{{ answerOption._id }}"
              />
              <span
                class="checkmark"
                [ngClass]="{ open: answerOption.isOpen }"
              ></span>
              <label
                class="body-2"
                for="{{ answerOption._id }}"
                *ngIf="!answerOption.isOpen"
              >
                {{ answerOption.text }}
              </label>
              <div class="ggi-input open-answer" *ngIf="answerOption.isOpen">
                <input
                  type="input"
                  (focus)="focusOpen()"
                  placeholder="{{ answerOption.text }}"
                  formControlName="openAnswer"
                />
              </div>
            </label>
          </div>

          <p class="subtitule-2">Notas</p>
          <div class="ggi-textarea">
            <textarea
              rows="5"
              formControlName="notes"
              id="notes"
              ggiJourneyControlValidator
              class="ggi-optional"
              [submitted]="form.get('notes')?.touched"
              placeholder="Escribe aquí tus notas..."
            >
            </textarea>
          </div>
        </div>
      </form>

      <div class="container-button">
        <button type="submit" class="btn-filled" (click)="submit()">
          Guardar y agendar cita
        </button>
      </div>
      <div class="center-button">
        <button type="button" class="btn-red" (click)="cancel()">
          Cancelar
        </button>
      </div>
    </div>
  </div>
</div>

<ggi-journey-modal-cancel
  [ngClass]="{ hidde: !showCancel }"
  [title]="'creación de este cliente'"
  (closeModal)="close()"
  (backForm)="back()"
>
</ggi-journey-modal-cancel>
